import { apiClient } from "./ApiClient";

export const acquireLockApi = (lock) =>
  apiClient.post(`/lock-view/lock/acquire`, lock);

export const releaseLockApi = (type, id) =>
  apiClient.get(`/lock-view/lock/release/${type}/${id}`);